var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 18.8332C15.4357 18.8332 19.1667 15.1022 19.1667 10.4998C19.1667 5.8975 15.4357 2.1665 10.8333 2.1665C6.231 2.1665 2.5 5.89742 2.5 10.4998C2.5 15.1023 6.231 18.8332 10.8333 18.8332ZM7.74417 8.589C7.41867 8.2635 7.41867 7.73617 7.74417 7.41059C8.06967 7.085 8.597 7.08509 8.92258 7.41059L10.8334 9.32142L12.7443 7.41059C13.0698 7.08509 13.5971 7.08509 13.9227 7.41059C14.2483 7.73609 14.2482 8.26342 13.9227 8.589L12.0118 10.4998L13.9227 12.4107C14.2482 12.7362 14.2482 13.2635 13.9227 13.5891C13.7599 13.7518 13.5467 13.8333 13.3335 13.8333C13.1203 13.8333 12.9071 13.7518 12.7443 13.5891L10.8335 11.6783L8.92267 13.5891C8.75992 13.7518 8.54667 13.8333 8.3335 13.8333C8.12033 13.8333 7.90708 13.7518 7.74433 13.5891C7.41883 13.2636 7.41883 12.7363 7.74433 12.4107L9.65517 10.4998L7.74417 8.589Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.516972e5c7fdf18cd633e07390af0634.svg";
export { ForwardRef as ReactComponent };